export const blockOptions=(t)=>[t("Opportunity")]